import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { HelpCircle } from "lucide-react";

const FAQ = () => {
  return (
    <section id="faq" className="section-spacing bg-gradient-to-b from-[#f5f5f5] to-white relative overflow-hidden">
      {/* Decorative element */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#4a9da8]/5 rounded-full blur-3xl"></div>

      <div className="container-custom relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16 fade-in">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#4a9da8]/10 text-[#4a9da8] text-sm font-semibold rounded-full border border-[#4a9da8]/20 mb-4">
              <HelpCircle className="w-4 h-4" />
              <span>Häufige Fragen</span>
            </div>
            <h2 className="text-5xl md:text-6xl font-bold text-[#0f1419] mb-6">
              Alles, was Sie
              <br />
              <span className="gradient-text">wissen müssen</span>
            </h2>
          </div>

          <Accordion type="single" collapsible className="space-y-4">
            <AccordionItem
              value="item-1"
              className="bg-white border-2 border-[#e8e4dc] hover:border-[#4a9da8]/30 rounded-2xl px-6 md:px-8 fade-in overflow-hidden transition-all duration-300"
            >
              <AccordionTrigger className="text-left text-lg md:text-xl font-semibold text-[#0f1419] hover:text-[#4a9da8] py-6 hover:no-underline">
                Wie lange dauert es, bis erste Ergebnisse sichtbar werden?
              </AccordionTrigger>
              <AccordionContent className="text-[#3a3a3a] leading-relaxed pb-6 text-base">
                Die ersten messbaren Veränderungen zeigen sich in der Regel nach 4–6 Wochen. Nachhaltiger Erfolg entwickelt sich über einen Zeitraum von mehreren Monaten durch kontinuierliche Optimierung.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem
              value="item-2"
              className="bg-white border-2 border-[#e8e4dc] hover:border-[#4a9da8]/30 rounded-2xl px-6 md:px-8 fade-in overflow-hidden transition-all duration-300"
              style={{animationDelay: '0.1s'}}
            >
              <AccordionTrigger className="text-left text-lg md:text-xl font-semibold text-[#0f1419] hover:text-[#4a9da8] py-6 hover:no-underline">
                Welchen zeitlichen Aufwand bedeutet die Zusammenarbeit für uns?
              </AccordionTrigger>
              <AccordionContent className="text-[#3a3a3a] leading-relaxed pb-6 text-base">
                Der operative Aufwand für Ihr Unternehmen ist minimal. Nach einer initialen Abstimmungsphase übernehmen wir die gesamte Umsetzung. Sie erhalten regelmäßige Updates und haben jederzeit Einblick in alle Aktivitäten.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem
              value="item-3"
              className="bg-white border-2 border-[#e8e4dc] hover:border-[#4a9da8]/30 rounded-2xl px-6 md:px-8 fade-in overflow-hidden transition-all duration-300"
              style={{animationDelay: '0.2s'}}
            >
              <AccordionTrigger className="text-left text-lg md:text-xl font-semibold text-[#0f1419] hover:text-[#4a9da8] py-6 hover:no-underline">
                Wie wird die Qualität der Inhalte sichergestellt?
              </AccordionTrigger>
              <AccordionContent className="text-[#3a3a3a] leading-relaxed pb-6 text-base">
                Alle Inhalte werden in Abstimmung mit Ihnen entwickelt und vor Veröffentlichung zur Freigabe vorgelegt. Sie behalten die volle Kontrolle über Ihre Außendarstellung.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem
              value="item-4"
              className="bg-white border-2 border-[#e8e4dc] hover:border-[#4a9da8]/30 rounded-2xl px-6 md:px-8 fade-in overflow-hidden transition-all duration-300"
              style={{animationDelay: '0.3s'}}
            >
              <AccordionTrigger className="text-left text-lg md:text-xl font-semibold text-[#0f1419] hover:text-[#4a9da8] py-6 hover:no-underline">
                Welche Plattformen werden betreut?
              </AccordionTrigger>
              <AccordionContent className="text-[#3a3a3a] leading-relaxed pb-6 text-base">
                Die Auswahl der Plattformen erfolgt strategisch basierend auf Ihrer Zielgruppe und Ihren Zielen. In der Regel konzentrieren wir uns auf LinkedIn, Instagram und Facebook – je nach Relevanz für Ihr Geschäftsmodell.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem
              value="item-5"
              className="bg-white border-2 border-[#e8e4dc] hover:border-[#4a9da8]/30 rounded-2xl px-6 md:px-8 fade-in overflow-hidden transition-all duration-300"
              style={{animationDelay: '0.4s'}}
            >
              <AccordionTrigger className="text-left text-lg md:text-xl font-semibold text-[#0f1419] hover:text-[#4a9da8] py-6 hover:no-underline">
                Wie werden die Ergebnisse gemessen?
              </AccordionTrigger>
              <AccordionContent className="text-[#3a3a3a] leading-relaxed pb-6 text-base">
                Alle Kennzahlen werden transparent erfasst und regelmäßig berichtet. Sie erhalten detaillierte Auswertungen zu Reichweite, Engagement, generierten Anfragen und weiteren relevanten Metriken.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem
              value="item-6"
              className="bg-white border-2 border-[#e8e4dc] hover:border-[#4a9da8]/30 rounded-2xl px-6 md:px-8 fade-in overflow-hidden transition-all duration-300"
              style={{animationDelay: '0.5s'}}
            >
              <AccordionTrigger className="text-left text-lg md:text-xl font-semibold text-[#0f1419] hover:text-[#4a9da8] py-6 hover:no-underline">
                Was unterscheidet marmoris von anderen Agenturen?
              </AccordionTrigger>
              <AccordionContent className="text-[#3a3a3a] leading-relaxed pb-6 text-base">
                Unser Fokus liegt auf Struktur, Nachvollziehbarkeit und Messbarkeit. Wir arbeiten datenbasiert statt trendgetrieben und sorgen für vollständige Transparenz in allen Prozessen.
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
